import { useEffect, useState } from 'react';

import { useLazyQuery } from '@apollo/client';

import { GET_PATIENTS } from '../gqlSchemes/getPatients';

const useLoadDashboardPatients = (searchPatients: string, filter: string) => {
  const [patients, setPatients] = useState('');
  const [pageNumber, setPageNumber] = useState(0);
  const [paginationInfo, setPaginationInfo] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [getPatients, { loading: loadingGetPatients, data }] = useLazyQuery(
    GET_PATIENTS,
    {
      fetchPolicy: 'no-cache',
      variables: {
        page: pageNumber,
        perPage: rowsPerPage,
        withCarePlan: true,
        filter: {
          name: filter
        },
      },
    }
  );

  useEffect(() => {
    if (searchPatients === '') {
      setPatients('');
      setPaginationInfo(null);
    } else {
      if (searchPatients === null) return;
      getPatients();
    }
  }, [getPatients, searchPatients]);

  useEffect(() => {
    if (data) {
      setPatients(data?.user?.patient?.patientPagination?.items);
      setPaginationInfo(data?.user?.patient?.patientPagination?.pageInfo);
    }
  }, [data]);

  return {
    patients,
    setPatients,
    pageNumber,
    setPageNumber,
    rowsPerPage,
    setRowsPerPage,
    loadingGetPatients,
    getPatients,
    setPaginationInfo,
    paginationInfo,
  }
}

export default useLoadDashboardPatients
